import { render, staticRenderFns } from "./NotificationSection.vue?vue&type=template&id=401dd287&scoped=true&"
import script from "./NotificationSection.vue?vue&type=script&lang=js&"
export * from "./NotificationSection.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSection.vue?vue&type=style&index=0&id=401dd287&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401dd287",
  null
  
)

export default component.exports